<form aria-labelledby="title">
  <h2 i18n="@@CompanyChoosing">Выбор компании</h2>
  <p class="form-content">

  <p>
    <input i18n-placeholder="@@SearchProduct"
           nbInput
           type="text"
           name="keyword" [(ngModel)]="keyword" (keyup)="onKey($event)"
           fullWidth fieldSize="small"
           placeholder="Поиск"/>
  </p>
  <ul *ngIf="filteredContracts?.length">
    <li *ngFor="let contract of filteredContracts">
      <a [class.selected]="selected == contract.id" (click)="select(contract)">
        {{ contract.counterParty.company }}
      </a>
      <small *ngIf="contract.header">{{ contract.header }}</small>
    </li>
  </ul>
</form>
